@defer (on viewport) {
<button class="lang-btn" (click)="currencyDialog = !currencyDialog">
  @if (isLoading) {
  <p-skeleton width="60px" height="25px" borderRadius="999px"></p-skeleton>
  } @else {
  <span class="fi fi-{{countryFlag ? countryFlag.toLowerCase() : ''}} fis"
    style="font-size: 28px; border-radius: 50%;"></span> <span>{{activeCurrency}}</span>
  }
</button>
} @placeholder {
<p-skeleton width="70.88px" height="31.6px" borderRadius="999px" styleClass="m-0"></p-skeleton>
}
<p-dialog header="Select your Language and Currency" [(visible)]="currencyDialog" [modal]="true"
  (onShow)="onOpenDialog()" [style]="{ width: '34rem', height: '420px' }">

  @if (currencyDialog) {
  <div class="p-2">
    <form [formGroup]="regionForm">
      <!--  country -->
      <div class="form-group country mb-3">
        <!-- dropdown -->
        @if (countries) {
        <p-dropdown [options]="countries" [(ngModel)]="selectedCountry" optionLabel="name" formControlName="country"
          dataKey="name" [filter]="true" [style]="{width: '100%'}" placeholder="Select a Country">
          <!-- Selected Item -->
          <ng-template pTemplate="selectedItem">
            @if (selectedCountry) {
            <div class="d-flex align-items-center justify-content-between flex-row-reverse gap-2 h-100">
              <!-- country flag of selected country -->
              <span class="fi fi-{{selectedCountry?.code ? selectedCountry.code.toLowerCase() : ''}} fis"
                style="font-size: 40px; border-radius: 50%;"></span>
              <!-- country name and map marker -->
              <div class="d-flex align-items-center gap-3">
                <i style="font-size: 24px;" class="pi pi-map-marker"></i>
                <div style="font-size: 20px; font-weight: 500;">{{ selectedCountry.name }}</div>
              </div>
            </div>
            }
          </ng-template>
          <!-- dropdown items -->
          <ng-template let-country pTemplate="item">
            <div class="d-flex align-items-center gap-3">
              <!-- country flag -->
              <span class="fi fi-{{country?.code ? country.code.toLowerCase() : ''}} fis"
                style="font-size: 30px; border-radius: 50%;"></span>
              <!-- country name -->
              <div style="font-size: 18px; font-weight: 500;">{{ country.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
        }
        @if (!countries?.length) {
        <p-skeleton width="100%" height="60px" borderRadius="999px"></p-skeleton>
        }
      </div>
      <!--  Language -->
      <div class="form-group language mb-3">
        <!-- dropdown -->
        <p-dropdown [options]="languages" [(ngModel)]="selectedLang" optionLabel="label" formControlName="lang"
          [style]="{width: '100%'}" placeholder="Select Language">
          <!-- Selected Item -->
          <ng-template pTemplate="selectedItem">
            @if (selectedLang) {
            <div class="d-flex align-items-center justify-content-end flex-row-reverse gap-3 h-100">
              <!-- language name -->
              <div style="font-size: 20px; font-weight: 500;">{{ selectedLang.label }}</div>
              <i style="font-size: 24px;" class="pi pi-language"></i>
            </div>
            }
          </ng-template>
          <!-- dropdown items -->
          <ng-template let-lang pTemplate="item">
            <div class="d-flex align-items-center gap-3">
              <!-- language name -->
              <div style="font-size: 18px; font-weight: 500;">{{ lang.label }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <!--  Currency -->
      <div class="form-group currency mb-4">
        <!-- dropdown -->
        <p-dropdown [options]="currencyList" [(ngModel)]="selectedCurrency" optionLabel="label"
          formControlName="currency" [style]="{width: '100%'}" placeholder="Select Language">
          <!-- Selected Item -->
          <ng-template pTemplate="selectedItem">
            @if (selectedCountry) {
            <div class="d-flex align-items-center justify-content-between flex-row-reverse gap-2 h-100">
              <!-- Icon of selected Currency -->
              <img [src]="selectedCurrency.icon" alt="{{ this.selectedCurrency.currency }} Currency Logo" width="40px"
                height="40px">
              <!-- Currency name and Currency Icon -->
              <div class="d-flex align-items-center gap-3">
                <i style="font-size: 24px;" class="pi pi-dollar"></i>
                <div style="font-size: 20px; font-weight: 500;">{{ this.selectedCurrency.currency }}</div>
              </div>
            </div>
            }
          </ng-template>
          <!-- dropdown items -->
          <ng-template let-currency pTemplate="item">
            <div class="d-flex align-items-center gap-3">
              <!-- currency icon -->
              <img [src]="currency.icon" alt="{{ currency.currency }} Currency Logo" width="30px" height="30px">
              <!-- currency name -->
              <div style="font-size: 18px; font-weight: 500;">{{ currency.currency }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <!-- Save Button -->
      <button class="save-button" (click)="updateRegionalSettings()">Save Settings</button>
    </form>
  </div>
  }

</p-dialog>




<p-toast></p-toast>